// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[1]!./flags/flags.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-badge {
  border-radius: var(--border-radius);
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
}
.product-badge.status-instock {
  background: var(--green-200);
  color: var(--green-800);
}
.product-badge.status-outofstock {
  background: var(--pink-200);
  color: var(--pink-800);
}
.product-badge.status-lowstock {
  background: var(--yellow-200);
  color: var(--yellow-800);
}

.product-badge-text {
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
}
.product-badge-text.status-instock {
  color: var(--green-500);
}
.product-badge-text.status-outofstock {
  color: var(--pink-500);
}
.product-badge-text.status-lowstock {
  color: var(--yellow-500);
}

.customer-badge {
  border-radius: var(--border-radius);
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
}
.customer-badge.status-qualified {
  background: var(--green-200);
  color: var(--green-800);
}
.customer-badge.status-unqualified {
  background: var(--pink-200);
  color: var(--pink-800);
}
.customer-badge.status-negotiation {
  background: var(--yellow-200);
  color: var(--yellow-800);
}
.customer-badge.status-new {
  background: var(--blue-200);
  color: var(--blue-800);
}
.customer-badge.status-renewal {
  background: var(--purple-200);
  color: var(--purple-800);
}
.customer-badge.status-proposal {
  background: var(--orange-200);
  color: var(--orange-800);
}

.order-badge {
  border-radius: var(--border-radius);
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
}
.order-badge.order-delivered {
  background: #c8e6c9;
  color: #256029;
}
.order-badge.order-cancelled {
  background: #ffcdd2;
  color: #c63737;
}
.order-badge.order-pending {
  background: #feedaf;
  color: #8a5340;
}
.order-badge.order-returned {
  background: #eccfff;
  color: #694382;
}

pre.app-code {
  background-color: var(--surface-ground);
  margin: 0 0 1rem 0;
  padding: 0;
  border-radius: var(--border-radius);
  overflow: auto;
}
pre.app-code code {
  color: var(--surface-900);
  padding: 1rem;
  line-height: 1.5;
  display: block;
  font-family: monaco, Consolas, monospace;
}

.block-viewer .block-section {
  margin-bottom: 4rem;
  overflow: hidden;
}
.block-viewer .block-header {
  padding: 1rem 2rem;
  background-color: var(--surface-section);
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  border: 1px solid var(--surface-d);
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.block-viewer .block-header .block-title {
  font-weight: 700;
  display: inline-flex;
  align-items: center;
}
.block-viewer .block-header .block-title .badge-free {
  border-radius: 4px;
  padding: 0.25rem 0.5rem;
  background-color: var(--orange-500);
  color: white;
  margin-left: 1rem;
  font-weight: 700;
  font-size: 0.875rem;
}
.block-viewer .block-header .block-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  margin-left: 1rem;
}
.block-viewer .block-header .block-actions a,
.block-viewer .block-header .block-actions button {
  display: flex;
  align-items: center;
  margin-right: 0.75rem;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  font-weight: 600;
  border: 1px solid transparent;
  transition: background-color 0.2s;
  cursor: pointer;
}
.block-viewer .block-header .block-actions a:last-child,
.block-viewer .block-header .block-actions button:last-child {
  margin-right: 0;
}
.block-viewer .block-header .block-actions a:not(.block-action-disabled):hover,
.block-viewer .block-header .block-actions button:not(.block-action-disabled):hover {
  background-color: var(--surface-c);
}
.block-viewer .block-header .block-actions a.block-action-active,
.block-viewer .block-header .block-actions button.block-action-active {
  border-color: var(--primary-color);
  color: var(--primary-color);
}
.block-viewer .block-header .block-actions a.block-action-copy i,
.block-viewer .block-header .block-actions button.block-action-copy i {
  color: var(--primary-color);
  font-size: 1.25rem;
  margin: 0;
}
.block-viewer .block-header .block-actions a.block-action-disabled,
.block-viewer .block-header .block-actions button.block-action-disabled {
  opacity: 0.6;
  cursor: auto !important;
}
.block-viewer .block-header .block-actions a i,
.block-viewer .block-header .block-actions button i {
  margin-right: 0.5rem;
}
.block-viewer .block-content {
  padding: 0;
  border: 1px solid var(--surface-d);
  border-top: 0 none;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  overflow: hidden;
}
.block-viewer .block-content pre.app-code {
  background-color: var(--surface-card) !important;
  padding-bottom: 1rem !important;
  margin-bottom: 0 !important;
}
.block-viewer .block-content pre.app-code code {
  padding: 1rem 2.5rem;
}
@media screen and (max-width: 575px) {
  .block-viewer .block-header {
    flex-direction: column;
    align-items: start;
  }
  .block-viewer .block-header .block-actions {
    margin-top: 1rem;
    margin-left: 0;
  }
}

.bg-circle {
  width: 1000px;
  height: 1000px;
  border-radius: 50%;
  background-image: linear-gradient(140deg, var(--primary-color), var(--surface-ground) 80%);
  position: absolute;
  opacity: 0.25;
  z-index: -1;
}

.visibility-hidden {
  visibility: hidden;
}

.moveinright {
  animation: moveinright 0.15s linear;
}

@keyframes moveinright {
  0% {
    opacity: 0;
    transform: translateX(50px);
    transition: transform 0.12s cubic-bezier(0, 0, 0.2, 1), opacity 0.12s cubic-bezier(0, 0, 0.2, 1);
  }
  100% {
    opacity: 1;
    transform: translateX(0%);
  }
}
.chip-remove-icon {
  width: 1.5rem;
  height: 1.5rem;
}
.chip-remove-icon i {
  font-size: 9px;
}

.upload-button-hidden.p-fileupload {
  padding: 0;
}
.upload-button-hidden.p-fileupload .p-fileupload-buttonbar {
  display: none;
}
.upload-button-hidden.p-fileupload .p-fileupload-content {
  border: 0 none;
}
.upload-button-hidden.p-fileupload .p-progressbar {
  display: none;
}

@media screen and (max-width: 768px) {
  .fc .fc-toolbar {
    justify-content: center;
  }
  .fc-header-toolbar {
    display: flex;
    align-items: center;
    gap: 1rem;
    justify-content: center;
    text-align: center;
    flex-wrap: wrap;
  }
  .fc-header-toolbar .fc-toolbar-chunk:nth-child(2) {
    width: 100%;
    order: 0;
  }
  .fc-header-toolbar .fc-toolbar-chunk:nth-child(1) {
    order: 1;
  }
  .fc-header-toolbar .fc-toolbar-chunk:nth-child(3) {
    order: 2;
  }
  .fc-header-toolbar .fc-toolbar-chunk:nth-child(3) .fc-button-group .fc-today-button {
    margin-left: 2rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/styles/demo/badges.scss","webpack://./src/main/webapp/styles/demo/Demos.scss","webpack://./src/main/webapp/styles/demo/code.scss","webpack://./src/main/webapp/styles/demo/BlockViewer.scss","webpack://./src/main/webapp/styles/demo/Landing.scss","webpack://./src/main/webapp/styles/demo/CustomFileUpload.scss","webpack://./src/main/webapp/styles/demo/Calendar.scss"],"names":[],"mappings":"AAAA;EACE,mCAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;ACEF;ADAE;EACE,4BAAA;EACA,uBAAA;ACEJ;ADCE;EACE,2BAAA;EACA,sBAAA;ACCJ;ADEE;EACE,6BAAA;EACA,wBAAA;ACAJ;;ADIA;EACE,gBAAA;EACA,eAAA;EACA,qBAAA;ACDF;ADGE;EACE,uBAAA;ACDJ;ADIE;EACE,sBAAA;ACFJ;ADKE;EACE,wBAAA;ACHJ;;ADOA;EACE,mCAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;ACJF;ADME;EACE,4BAAA;EACA,uBAAA;ACJJ;ADOE;EACE,2BAAA;EACA,sBAAA;ACLJ;ADQE;EACE,6BAAA;EACA,wBAAA;ACNJ;ADSE;EACE,2BAAA;EACA,sBAAA;ACPJ;ADUE;EACE,6BAAA;EACA,wBAAA;ACRJ;ADWE;EACE,6BAAA;EACA,wBAAA;ACTJ;;ADaA;EACE,mCAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;ACVF;ADYE;EACE,mBAAA;EACA,cAAA;ACVJ;ADaE;EACE,mBAAA;EACA,cAAA;ACXJ;ADcE;EACE,mBAAA;EACA,cAAA;ACZJ;ADeE;EACE,mBAAA;EACA,cAAA;ACbJ;;AC7FA;EACE,uCAAA;EACA,kBAAA;EACA,UAAA;EACA,mCAAA;EACA,cAAA;ADgGF;AC9FE;EACE,yBAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,wCAAA;ADgGJ;;AE3GE;EACE,mBAAA;EACA,gBAAA;AF8GJ;AE3GE;EACE,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,6BAAA;EACA,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AF6GJ;AE3GI;EACE,gBAAA;EACA,oBAAA;EACA,mBAAA;AF6GN;AE3GM;EACE,kBAAA;EACA,uBAAA;EACA,mCAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AF6GR;AEzGI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBAAA;KAAA,sBAAA;UAAA,iBAAA;EACA,iBAAA;AF2GN;AEzGM;;EAEE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,iCAAA;EACA,eAAA;AF2GR;AEzGQ;;EACE,eAAA;AF4GV;AEzGQ;;EACE,kCAAA;AF4GV;AEzGQ;;EACE,kCAAA;EACA,2BAAA;AF4GV;AExGU;;EACE,2BAAA;EACA,kBAAA;EACA,SAAA;AF2GZ;AEvGQ;;EACE,YAAA;EACA,uBAAA;AF0GV;AEvGQ;;EACE,oBAAA;AF0GV;AEpGE;EACE,UAAA;EACA,kCAAA;EACA,kBAAA;EACA,+BAAA;EACA,gCAAA;EACA,gBAAA;AFsGJ;AEpGI;EACE,gDAAA;EACA,+BAAA;EACA,2BAAA;AFsGN;AEpGM;EACE,oBAAA;AFsGR;AEjGE;EACE;IACE,sBAAA;IACA,kBAAA;EFmGJ;EEjGI;IACE,gBAAA;IACA,cAAA;EFmGN;AACF;;AGlNA;EACE,aAAA;EACA,cAAA;EACA,kBAAA;EACA,0FAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;AHqNF;;AGlNA;EACE,kBAAA;AHqNF;;AGlNA;EACE,mCAAA;AHqNF;;AGlNA;EACE;IACE,UAAA;IACA,2BAAA;IACA,gGACE;EHoNJ;EGjNA;IACE,UAAA;IACA,yBAAA;EHmNF;AACF;AIhPA;EACE,aAAA;EACA,cAAA;AJkPF;AIhPE;EACE,cAAA;AJkPJ;;AI7OE;EACE,UAAA;AJgPJ;AI9OI;EACE,aAAA;AJgPN;AI7OI;EACE,cAAA;AJ+ON;AI5OI;EACE,aAAA;AJ8ON;;AKpQA;EACE;IACE,uBAAA;ELuQF;EKpQA;IACE,aAAA;IACA,mBAAA;IACA,SAAA;IACA,uBAAA;IACA,kBAAA;IACA,eAAA;ELsQF;EKpQE;IACE,WAAA;IACA,QAAA;ELsQJ;EKnQE;IACE,QAAA;ELqQJ;EKlQE;IACE,QAAA;ELoQJ;EKjQM;IACE,iBAAA;ELmQR;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
